export const CustomCell = (props: any) => {
  const {
    index,
    isNumeric,
    cellName,
    placeholder,
    defaultValue,
    handleChange,
    hidden = false,
    autoFocus = false,
    confirmRow = () => {},
    cancelRow = () => {},
    customItem,
  } = props;

  const handleKeyPress = (e: any) => {
    // Accept only numbers
    if (isNumeric && !/^(0|[1-9][0-9]*)$/.test(e.key)) {
      e.preventDefault();
    }
  };

  return (
    <>
      <input
        data-cellname={cellName}
        id={cellName}
        className={`modify-cell ${isNumeric ? "numeric-cell" : ""}`}
        placeholder={placeholder}
        type={
          cellName === "total_price" || cellName === "category_name" || hidden
            ? "hidden"
            : isNumeric
            ? "number"
            : "text"
        }
        defaultValue={
          defaultValue ? defaultValue : cellName === "quantity" ? 1 : ""
        }
        autoFocus={autoFocus}
        tabIndex={index}
        //onKeyPress={handleKeyPress}
        onChange={handleChange}
        onFocus={cellName === "manufacturer_name" ? handleChange : null}
        onKeyDown={(event) => {
          if (
            event.key === "Enter" &&
            ((cellName === "product_name" && customItem && !customItem.fetchedItem) ||
              (cellName !== "product_name" && cellName !== "manufacturer_name"))
          ) {
            confirmRow();
          } else if (
            event.key === "Enter" &&
            (cellName === "product_name" || cellName === "manufacturer_name") &&
            customItem &&
            (customItem.fetchedItem || customItem.fetchedManufacturer)
          ) {
            $("#quantity").trigger("focus");
          } else if (event.key === "Escape") {
            cancelRow();
          }
        }}
      />
    </>
  );
};
